import Module from 'lib/module';
import Util from 'lib/util';
import jquery from 'jquery';

@Module.define('product-ind')
class ProductInd extends Module {
    main() {

        this.formSubmit();

        $('#corePrice').text($('#coreParts').find(':selected').data('billprice'))
        $('#plusPrice').text($('#plusParts').find(':selected').data('billprice'))

        $('#coreParts').on('change', function (e) {
            $('#corePrice').text($(this).find(':selected').data('billprice'));
        });

        $('#plusParts').on('change', function (e) {
            $('#plusPrice').text($(this).find(':selected').data('billprice'));
        });

        $('#allCollapseUp').on('click', function (e) {
            allCollapseUp(false);
        });

        $('#allCollapseDown').on('click', function (e) {
            $('#toolsBullets').slideDown();
            $('#allCollapsible').animate({
                height: '100%'
            });

             $('#allCollapseUp').css('display', 'block');
            $('#allCollapseDown').css('display', 'none');
            $('#allCollapseDown').next().html('See less features');
        });

        $('#coreCollapseUp').on('click', function (e) {
            coreCollapseUp(false);
        });

        $('#coreCollapseDown').on('click', function (e) {
            $('.coreBullets').slideDown();

            if (Util.checkWidth() === "desktopNarrow" || Util.checkWidth() === "desktopWide") {
                $('#coreCollapsible').animate({
                    height: '870px',
                });
            }
            else {
                $('#coreCollapsible').animate({
                    height: '100%',
                });

            }

            $('#coreCollapseUp').css('display', 'block');
            $('#coreCollapseDown').css('display', 'none');
            $('#coreCollapseDown').next().html('See less features');
        });

        $('#plusCollapseUp').on('click', function (e) {
            plusCollapseUp(false);
        });

        $('#plusCollapseDown').on('click', function (e) {
            $('.plusBullets').slideDown();

            if (Util.checkWidth() === "desktopNarrow" || Util.checkWidth() === "desktopWide") {
                $('#plusCollapsible').animate({
                    height: '870px',
                });
            }
            else {
                $('#plusCollapsible').animate({
                    height: '100%',
                });

            }

            $('#plusCollapseUp').css('display', 'block');
            $('#plusCollapseDown').css('display', 'none');
            $('#plusCollapseDown').next().html('See less features');
        });

        $('#plusParts').on('change', function () {
            if (this.value === '1067') {
                $('#plusOffer').css('visibility', 'visible');
            }
            else {
                $('#plusOffer').css('visibility', 'hidden');
            }
        });

        $('#coreParts').on('change', function () {
            if (this.value === '1061') {
                $('#coreOffer').css('visibility', 'visible');
            }
            else {
                $('#coreOffer').css('visibility', 'hidden');
            }
        });

        function allCollapseUp(startup) {
            var height = $('#allCollapsible').height() + 'px';

            var sumHeight = 0;
            $('#allRightSide').children().slice(0, 3).each(function (i) {
                sumHeight += $(this).height();
            });

            sumHeight += 5;

            scrollViewport($('#allCollapsible')[0]);

            if (startup) {
                $('#toolsBullets').hide();
                $('#allCollapsible').height(sumHeight);
            }
            else {
                $('#allCollapsible').animate({
                    height: sumHeight,
                });

                $('#toolsBullets').slideUp();
            }

            $('#allCollapseUp').css('display', 'none');
            $('#allCollapseDown').css('display', 'block');
            $('#allCollapseDown').next().html('See more features');
        }

        function coreCollapseUp(startup) {
            var height = $('#coreCollapsible').height() + 'px';

            var sumHeight = 0;
            $('.coreCheckmarks').each(function (i) {
                sumHeight += $(this).height();
            });

            sumHeight += 5;

            scrollViewport($('#coreCollapsible')[0]);

            if (startup) {
                $('.coreBullets').hide();
                $('#coreCollapsible').height(sumHeight);
            }
            else {
                $('#coreCollapsible').animate({
                    height: sumHeight
                });

                $('.coreBullets').slideUp();
            }

            $('#coreCollapseUp').css('display', 'none');
            $('#coreCollapseDown').css('display', 'block');
            $('#coreCollapseDown').next().html('See more features');
        }

        function plusCollapseUp(startup) {
            var height = $('#plusCollapsible').height() + 'px';

            var sumHeight = 0;
            $('.plusCheckmarks').each(function (i) {
                sumHeight += $(this).height();
            });

            sumHeight += 5;

            scrollViewport($('#plusCollapsible')[0]);

            if (startup) {
                $('.plusBullets').hide();
                $('#plusCollapsible').height(sumHeight);
            }
            else {
                $('#plusCollapsible').animate({
                    height: sumHeight
                });

                $('.plusBullets').slideUp();
            }

            $('#plusCollapseUp').css('display', 'none');
            $('#plusCollapseDown').css('display', 'block');
            $('#plusCollapseDown').next().html('See more features');
        }

        function scrollViewport(element) {
            var rect = element.getBoundingClientRect();

            // If the section element is ABOVE THE VIEWPORT, adjust the scroll.
            if (rect.top < 0) {

                window.scrollBy(0, (rect.top));
            }
        }

        if (Util.checkWidth() === "mobile" || Util.checkWidth() === "tablet") {
            allCollapseUp(true);
            coreCollapseUp(true);
            plusCollapseUp(true);
        }
    }

    bindEvents() {
    }

    formSubmit() {

        $('#product-form-core, #product-form-plus').on('submit', function (e) {
            e.preventDefault();
            let productSKU = $(this).find(':selected').attr('value');
            let formActionUrl = $(this).attr('action');
            let redirectUrl = `${formActionUrl}?product=${productSKU}`
            //$('#product-form').attr('action', `${formActionUrl}?sku=${productSKU}`);
            window.location = redirectUrl;
        });

    
    }
}